import React, { Component } from 'react';

class CalendarMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Calendário </h2>
                <p>
                    Nesta página encontra um calendário atualizado com eventos da edição ativa na data selecionada.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar um evento</li>
                    <li>Associar um evento ao calendário</li>
                </ul>
            </div>
        );
    }
}
export default CalendarMetadata;



// WEBPACK FOOTER //
// ./src/components/metadata/datamanager/CalendarMetadata.js